import React from "react";
import AdminSidebar from "../components/AdminSidebar";
import Foooter from "../components/Foooter";

const AdminLayout = ({ children, ...props }) => {
  return (
    <div className="flex md:flex-row min-h-screen w-full">
      <AdminSidebar />
      <div className="flex-1 min-h-screen overflow-auto w-full">
        <div className="flex flex-col justify-between min-h-screen h-screen overflow-auto">
          <div className="p-2 sm:p-3 md:p-5">{children}</div>
          <div className="sticky bottom-0 w-full">
            <Foooter />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminLayout;
